<template>
  <div>
    <h3>You can not delete this as this has been referred to somewhere else.</h3>
    <!-- <h3>This subject is associated to these records </h3>
    <vs-list>
      <vs-list-header title="Courses" v-if="courseList.length"></vs-list-header>
      <div v-for="(eachList,index) in courseList" :key="'c'+index">
        <span @click="pushCourse(eachList.slug)" style="color:blue" class="cursor-pointer">
          <vs-list-item :title="eachList.name" ></vs-list-item>
        </span>
      </div>

      <vs-list-header title="Lessons" v-if="lessonList.length"></vs-list-header>
      <div v-for="(eachList,index) in lessonList" :key="'l'+index">
        <vs-list-item :title="eachList.name"></vs-list-item>
      </div>

      <vs-list-header title="Topics" v-if="topicList.length"></vs-list-header>
      <div v-for="(eachList,index) in topicList" :key="'t'+index">
        <vs-list-item :title="eachList.name"></vs-list-item>
      </div>

      <vs-list-header title="Homeworks" v-if="hwList.length"></vs-list-header>
      <div v-for="(eachList,index) in hwList" :key="'h'+index">
        <vs-list-item :title="eachList.name"></vs-list-item>
      </div>

      <vs-list-header title="Exams" v-if="examList.length"></vs-list-header>
      <div v-for="(eachList,index) in examList" :key="'e'+index">
        <vs-list-item :title="eachList.name"></vs-list-item>
      </div>

    </vs-list> -->
  </div>
</template>

<script>
export default {
  props:{
    additionalInfo: {
      type: Array,
      required:true,
      default:() => []
    }
  },
  created () {
    
    this.courseList = this.additionalInfo.filter(ele => {
      
      if ('courses' in ele && ele.courses) {
        return ele
      }

    }).map(ele => {
      return {
        name:ele.courses.name,
        type:'course',
        slug:ele.courses.slug
      }
    })

    this.lessonList = this.additionalInfo.filter(ele => {
      
      if ('lessons' in ele && ele.lessons) {
        return ele
      }

    }).map(ele => {
      return {
        name:ele.lessons.name,
        type:'lesson',
        slug:ele.lessons.slug

      }
    })

    this.topicList = this.additionalInfo.filter(ele => {
      
      if ('topic' in ele && ele.topics) {
        return ele
      }

    }).map(ele => {
      return {
        name:ele.topics.name,
        type:'topic',
        slug:ele.topics.slug

      }
    })
    /*   this.lessonList = this.additionalInfo.map(ele => {
      
      if ('lessons' in ele ) {
          
        return {
          name:ele.name,
          type:'Lesson'
        }
      }

    })
    this.topicList = this.additionalInfo.map(ele => {
      
      if ('topics' in ele) {
        return {
          name:ele.name,
          type:'Topic'
        }
      }

    }) */
    

  },
  data () {
    return {
      courseList:[],
      topicList:[],
      lessonList:[]
    }
  },
  methods:{
    pushCourse (slug) {
      
      const routeData = this.$router.resolve({
        name: 'courseListing',
        params: { slug }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>